import React, { useState } from 'react';
import { FormDetail } from './FormDetail';
import Swal from 'sweetalert2'

export function FormPage({ 
  initialDocument, 
  form, 
  sessionID, 
  recordDocument, 
  rulesPerPage,
  detailsPerPage, 
  validate,
  dynamicModifications
}) {

  let [document, setDocument] = useState(initialDocument);
  let [actualForm, setActualForm] = useState(form);

  
  function updateDocument(o) {
    console.log(o);
    let updatedDocument = { ...document, ...o };
    const r = dynamicModifications(form, updatedDocument);
    setDocument(r.newDocument);
    setActualForm(r.newForm);
  }

  const props = {
    form: actualForm, 
    document, 
    isMultiPage : true,
    setDocument, 
    updateDocument, 
    recordDocument, 
    sessionID,
    rulesPerPage,
    detailsPerPage,
    validate
  };

  return <FormDetail {...props}></FormDetail>
}